// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox___vwk_","dark":"Checkbox_dark__cIXWO"};